module.exports = "https://qp-assets.quero.com/assets/images/landing/smiling-face-with-heart-shaped-eyes.png?1debb624f9162603280c1deac3cebd99";